import { Pipe, PipeTransform } from '@angular/core';
import { LocalDate } from '../../store/models';
import { getCurrentDate, timestampDurationAsString } from '../utils';
import { NOT_AVAILABLE } from '../constants';

@Pipe({
    name: 'elapsedTime',
    standalone: false
})
export class ElapsedTimePipe implements PipeTransform {
  transform(date: LocalDate): string {
    const elapsedTime: string = date
      ? timestampDurationAsString(date.timestamp, getCurrentDate().getTime())
      : NOT_AVAILABLE;

    return elapsedTime;
  }
}
